/* Coshi — falling marigold petals, the canvas layer of the festival doorway.

   Genda phool petals drift down through the page in depth: far petals are
   small, pale and slow, near ones large, saturated and quick, and every petal
   flips as it falls. The vertical scale is driven by a cosine, which is what
   reads as a petal turning over in air rather than a rotating sticker.

   Each petal is a SPRITE rendered once per colour into an offscreen canvas and
   then blitted with a rotation. Building a gradient per petal per frame is what
   makes this kind of effect stutter on a phone; three sprites cost three draws
   at startup and nothing afterwards.

   The page dispatches 'coshi:utterance' when the deity answers — that scatters
   fresh petals from above, like pushpanjali, and gusts the wind.

   Budget scales to the DEVICE, not the viewport. */
(function () {
  'use strict';

  var TAU = Math.PI * 2;

  var PALETTE = [
    ['#FFD25E', '#D2560B'],
    ['#F5A623', '#C1440E'],
    ['#FFDE7A', '#E08A12']
  ];

  function isLowEnd() {
    try {
      var cores = navigator.hardwareConcurrency;
      if (typeof cores === 'number' && cores > 0 && cores < 4) return true;
      var mem = navigator.deviceMemory;
      if (typeof mem === 'number' && mem > 0 && mem <= 2) return true;
    } catch (e) {}
    return false;
  }

  function petalSprite(c1, c2) {
    var S = 72;
    var cv = document.createElement('canvas');
    cv.width = S; cv.height = S;
    var c = cv.getContext('2d');
    var g = c.createLinearGradient(S / 2, 4, S / 2, S - 6);
    g.addColorStop(0, c1);
    g.addColorStop(1, c2);
    c.beginPath();
    c.moveTo(S / 2, 5);
    c.bezierCurveTo(S - 12, 17, S - 10, 46, S / 2, S - 6);
    c.bezierCurveTo(10, 46, 12, 17, S / 2, 5);
    c.closePath();
    c.fillStyle = g;
    c.fill();
    /* the crease down the middle of a marigold petal */
    c.beginPath();
    c.moveTo(S / 2, 12);
    c.lineTo(S / 2, S - 12);
    c.strokeStyle = 'rgba(255,240,190,.45)';
    c.lineWidth = 1.6;
    c.stroke();
    return cv;
  }

  function start() {
    var cv = document.querySelector('.cs-bg__canvas');
    if (!cv || cv.getAttribute('data-on')) return;
    try {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    } catch (e) {}

    var ctx = cv.getContext('2d');
    if (!ctx) return;
    cv.setAttribute('data-on', '1');

    var weak = isLowEnd();
    var dpr = Math.min(window.devicePixelRatio || 1, weak ? 1 : 1.5);
    var COUNT = weak ? 16 : 44;

    var sprites = PALETTE.map(function (p) { return petalSprite(p[0], p[1]); });

    var w = 0, h = 0, petals = [], raf = null, last = 0, t = 0;
    var wind = 0, gust = 0;

    function size() {
      w = cv.clientWidth; h = cv.clientHeight;
      cv.width = Math.round(w * dpr);
      cv.height = Math.round(h * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function make(p, fromTop) {
      var d = Math.random();                 /* 0 near, 1 far */
      p.d = d;
      p.x = Math.random() * (w + 160) - 80;
      p.y = fromTop ? -40 - Math.random() * 200 : Math.random() * h;
      p.sz = (34 - d * 20) * (0.85 + Math.random() * 0.4);
      p.fall = 78 - d * 46;
      p.rot = Math.random() * TAU;
      p.rotSpd = (Math.random() - 0.5) * 1.1;
      p.flip = Math.random() * TAU;
      p.flipSpd = 1 + Math.random() * 1.6;
      p.sway = 14 + Math.random() * 30;
      p.swayPh = Math.random() * TAU;
      p.a = 0.42 + (1 - d) * 0.5;
      p.sp = sprites[(Math.random() * sprites.length) | 0];
      p.vx = 0;
      return p;
    }

    function seed() {
      petals = [];
      for (var i = 0; i < COUNT; i++) petals.push(make({}, false));
      /* far petals first so near ones layer over them */
      petals.sort(function (a, b) { return b.d - a.d; });
    }

    function frame(now) {
      var dt = last ? Math.min((now - last) / 1000, 0.05) : 0;
      last = now;
      t += dt;

      if (gust > 0) gust = Math.max(0, gust - dt * 0.6);
      wind = Math.sin(t * 0.24) * 16 + Math.sin(t * 0.09) * 10 + gust * 90;

      ctx.clearRect(0, 0, w, h);

      for (var i = 0; i < petals.length; i++) {
        var p = petals[i];
        var near = 1 - p.d;

        p.y += p.fall * (1 + gust * 0.5) * dt;
        p.x += (wind * (0.35 + near * 0.65) + Math.sin(t * 1.3 + p.swayPh) * p.sway) * dt;
        p.x += p.vx * dt;
        p.vx *= (1 - Math.min(1, dt * 1.4));
        p.rot += p.rotSpd * dt;
        p.flip += p.flipSpd * dt;

        if (p.y > h + 60 || p.x < -140 || p.x > w + 140) { make(p, true); continue; }

        var s = p.sz;
        var fy = Math.cos(p.flip);
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.scale(1, fy);
        ctx.globalAlpha = p.a * (0.55 + 0.45 * Math.abs(fy));
        ctx.drawImage(p.sp, -s / 2, -s / 2, s, s);
        ctx.restore();
      }
      ctx.globalAlpha = 1;

      raf = requestAnimationFrame(frame);
    }

    function play() { if (!raf) { last = 0; raf = requestAnimationFrame(frame); } }
    function stop() { if (raf) { cancelAnimationFrame(raf); raf = null; } }

    size(); seed(); play();

    /* pushpanjali: the deity answers, petals are offered from above */
    document.addEventListener('coshi:utterance', function () {
      gust = 1;
      var n = weak ? 4 : 9;
      for (var i = 0; i < n && i < petals.length; i++) {
        var p = petals[(Math.random() * petals.length) | 0];
        make(p, true);
        p.x = w * (0.3 + Math.random() * 0.4);
        p.y = -30 - Math.random() * 80;
        p.vx = (Math.random() - 0.5) * 220;
      }
    });

    var rt = null;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { size(); seed(); }, 180);
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else play();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else { start(); }
})();
